import React from 'react'
import ReactDOM from 'react-dom';
import Loading from '../../components/shared/Loading'
import {Button} from 'react-bootstrap';
import FileViewer from 'react-file-viewer';
import { Modal } from 'react-bootstrap';
import classnames from 'classnames';

class PDFLinkViewer extends React.Component {
    constructor(props) {
        super(props);
        this.state={
            count: 0,
            url: this.props.url,
            loading: false,
        }
    }

    handleNextPdf = () => {
        this.props.handleNextPdf()
    }
    handlePrevPdf = () => {
     this.props.handlePrevPdf()
    }
    componentWillReceiveProps(nextProps) {
        this.setState({
            url: nextProps.url,
            loading: nextProps.url?false:true,
        })
 }
    render() {
        let url= this.state.url;
        return (
            <div>
        {this.state.loading && <Loading classes="loading centre-position" />}
        {this.props.count>=0 && url && <FileViewer key={this.props.count} fileType={'pdf'} filePath={url} />}
            </div>
        )
    }
}

export default PDFLinkViewer;
